import { render, staticRenderFns } from "./add_warranty.vue?vue&type=template&id=6da64615&scoped=true&"
import script from "./add_warranty.vue?vue&type=script&lang=js&"
export * from "./add_warranty.vue?vue&type=script&lang=js&"
import style0 from "./add_warranty.vue?vue&type=style&index=0&id=6da64615&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da64615",
  null
  
)

export default component.exports